import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={33}
    height={32}
    viewBox="0 0 33 32"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#2D27F6'}
      d="m10.93 8.532 1.83 3.16H9.1l1.83-3.16Zm2.65 4.59-.14-.24H8.42l-1.32 2.29c-.11.18-.3.3-.51.3a.64.64 0 0 1-.3-.08.595.595 0 0 1-.22-.79l4.34-7.54c.16-.28.52-.38.81-.22.09.05.17.13.22.22l3.03 5.24a11.51 11.51 0 0 1 6.77-2.73c-.86-5.69-6.18-9.61-11.87-8.74-5.69.86-9.61 6.18-8.74 11.87.32 2.13 1.3 4.11 2.8 5.67l-2.7 2.11c-.26.2-.3.57-.1.83.11.14.28.23.47.23h9.27v-.39c0-2.98 1.15-5.85 3.22-8l-.01-.03Zm6.05 5.92c.41 1.6 1.21 3.06 2.34 4.26a9.871 9.871 0 0 0 2.34-4.26h-4.69.01Zm12.54 11.48c.26.2.3.57.1.83-.11.14-.28.23-.47.23h-9.83c-5.77 0-10.46-4.66-10.47-10.44 0-5.77 4.66-10.46 10.44-10.47 5.77 0 10.46 4.66 10.47 10.44 0 2.72-1.05 5.33-2.94 7.29l2.7 2.13v-.01Zm-9.31-6.45c1.3-1.42 2.22-3.15 2.67-5.02h1.02c.33 0 .59-.26.59-.59 0-.33-.26-.59-.59-.59h-3.98v-1.39c0-.33-.26-.59-.59-.59-.33 0-.59.26-.59.59v1.39h-3.98c-.33 0-.59.26-.59.59 0 .33.26.59.59.59h1.02c.45 1.87 1.36 3.59 2.65 5.01a6.47 6.47 0 0 1-3.55 1.18c-.33 0-.59.28-.58.6 0 .33.28.59.6.58h.03c1.6-.05 3.14-.59 4.4-1.56 1.26.96 2.8 1.51 4.39 1.55h.03c.33 0 .6-.25.6-.58 0-.33-.25-.6-.58-.6a6.539 6.539 0 0 1-3.55-1.17l-.01.01Z"
    />
  </Svg>
);
export default SvgComponent;
